import Button from 'react-bootstrap/Button';
import React from "react";
import Shape from '../images/Shape.png';
import Rectangle from '../images/Rectangle.png';
import Welcomebackground from '../images/WelBackground.png';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Link } from 'react-router-dom';

function welcome() {
  return (
    <div className="App"
      style={{
        width: '100%',
        height: '753px',
        backgroundColor: '#FFFFFF',
        textAlign: 'center'
      }}>
      <div className="topBar"
        style={{ padding: '13px' }}>
        <img src={Shape} style={{ width: '65px', height: '17px' }} alt="" />
      </div>
      <div >
        <img src={Rectangle} style={{ width: '100%', height: '66px' }} alt="" />
      </div>
      <div
        style={{
          width: '100%',
          height: '355px',
          backgroundImage: `url(${Welcomebackground})`
        }}>
        <h6>WELCOME TO</h6>
        <div>
          <img src={Shape} style={{ width: '125px', height: '33px' }} alt="" />
        </div>
      </div>
      <div
        style={{
          padding: '25px'
        }}>
        <span style={{
          fontSize: '13px',
          fontWeight: '400'
        }}>
          Congratulations on your purchase!Register with IQOS and join a community of fans who are making the switch.
        </span>
        <div style={{
          marginTop: '20px'
        }}>
          <Link to="/userInformation">
            <Button variant="success" size="lg" type="submit" style={{
              height: '35px',
              width: '153px',
              fontSize: '12px',
              fontWeight: '700',
              borderRadius: '0',
              color: '#FFFFFF',
              backgroundColor: '#00A78A'
            }}>
              REGISTER NOW
            </Button>
          </Link>
        </div>
        <div style={{
          fontSize: '11px',
          lineHeight: '15px',
          fontWeight: '400',
          marginTop: '20px'
        }}>
          <p>© 2020 PHILIP MORRIS USA INC.</p>
        </div>
      </div>
    </div >
  );
}
export default welcome;